// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import ZoomInOutlinedSvg from "@ant-design/icons-svg/lib/asn/ZoomInOutlined";
import AntdIcon from "../components/AntdIcon";
const ZoomInOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: ZoomInOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    ZoomInOutlined.displayName = "ZoomInOutlined";
}
export default /*#__PURE__*/ React.forwardRef(ZoomInOutlined);
